import React from 'react'
import Link from '@toasttab/shared/src/components/atoms/Link/Link'
import { SectionCTAProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const SectionCTA = ({ title, description, url }: SectionCTAProps) => {
  return (
    <div className='block md:hidden border-y border-gray-25 mt-14 mb-8 pt-8 pb-[47px] px-4'>
      <h5 className='font-sansPro font-semibold text-default text-base leading-6'>
        {title}
      </h5>
      <p className='font-sansPro text-secondary text-base'>{description}</p>
      <Link to={url} className='flex font-semibold text-blue-75'>
        Learn more{' '}
        <svg
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
          className='ml-1 transition-all group-hover:translate-x-[7px] stroke-blue-75 group-hover:stroke-blue-100'
        >
          <path
            d='M18 12H6M18 12L15.208 9M18 12L15.208 15'
            stroke=''
            strokeWidth='1.5'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
        </svg>
      </Link>
    </div>
  )
}

export default SectionCTA
